import { motion } from 'framer-motion';

// Deterministic bar data — height + speed variation for organic music feel
const BARS = [
  { h: 28, s: 0.00 }, { h: 42, s: 0.18 }, { h: 62, s: 0.05 },
  { h: 38, s: 0.28 }, { h: 75, s: 0.12 }, { h: 55, s: 0.22 },
  { h: 88, s: 0.08 }, { h: 48, s: 0.32 }, { h: 70, s: 0.15 },
  { h: 35, s: 0.25 }, { h: 80, s: 0.04 }, { h: 60, s: 0.20 },
  { h: 92, s: 0.10 }, { h: 45, s: 0.30 }, { h: 65, s: 0.07 },
  { h: 38, s: 0.24 }, { h: 85, s: 0.14 }, { h: 58, s: 0.02 },
  { h: 72, s: 0.19 }, { h: 42, s: 0.27 }, { h: 95, s: 0.09 },
  { h: 52, s: 0.16 }, { h: 78, s: 0.23 }, { h: 44, s: 0.06 },
  { h: 66, s: 0.13 }, { h: 36, s: 0.29 }, { h: 82, s: 0.03 },
  { h: 55, s: 0.21 }, { h: 48, s: 0.11 }, { h: 68, s: 0.26 },
  { h: 32, s: 0.17 }, { h: 74, s: 0.08 }, { h: 58, s: 0.31 },
  { h: 90, s: 0.14 }, { h: 46, s: 0.05 }, { h: 63, s: 0.22 },
];

const Hero = () => (
  <section id="home" className="hero">
    {/* Background */}
    <div className="hero__bg">
      <img
        src="/home_banner.webp"
        alt="Pixie DJ"
        className="hero__bg-img"
        loading="eager"
        fetchpriority="high"
      />
      <div className="hero__bg-overlay" />
      <div className="hero__bg-boxes" aria-hidden="true" />
    </div>

    {/* Content */}
    <div className="hero__content">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
      >
        <img src="/pixie_loog.png" alt="Pixie" className="hero__logo" />
      </motion.div>

      <motion.p
        className="hero__tagline"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.65 }}
      >
        DJ &middot; MUSIC PRODUCER &middot; INFLUENCER
      </motion.p>

      {/* Waveform */}
      <motion.div
        className="hero__waveform"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.9 }}
        aria-hidden="true"
      >
        {BARS.map(({ h, s }, i) => (
          <span
            key={i}
            className="hero__bar"
            style={{ '--h': `${h}%`, '--speed': `${s}s` }}
          />
        ))}
      </motion.div>

      {/* CTA Buttons */}
      <motion.div
        className="hero__cta"
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 1.1 }}
      >
        <a
          href="https://open.spotify.com/artist/31oJrnH9M6mvsdEtUgN1Os"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn--primary"
        >
          <IconPlay /> Listen on Spotify
        </a>
        <a
          href="https://www.youtube.com/@djpixie_official"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn--ghost"
        >
          <IconYoutube /> YouTube Channel
        </a>
        <a href="#events" className="btn btn--ghost">
          <IconCalendar /> Upcoming Shows
        </a>
      </motion.div>
    </div>

    {/* Scroll dot indicator */}
    <div className="hero__indicator" aria-hidden="true">
      <span className="hero__dot hero__dot--active" />
    </div>
  </section>
);

const IconPlay = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M8 5v14l11-7z" />
  </svg>
);
const IconYoutube = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
  </svg>
);
const IconCalendar = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" />
  </svg>
);

export default Hero;
